<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    :key="item.id"
    class="d-flex flex-col"
    v-for="item in value"
  >
    <ItpText
      pre
      :text="item.message"
    >
    </ItpText>
    <UcValidityPeriod
      :from="item.valid_from"
      :to="item.valid_to"
      class="ml-2"
      v-if="item.valid_from || item.valid_to"
    >
    </UcValidityPeriod>
    <DIV
      :title="'Displays'|pgettext('TransactionNotesDisplay')"
      class="ml-2"
      v-if="item.max_displays != null"
    >
      {{ item.counter }} / {{ item.max_displays }}
    </DIV>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class TransactionNotesDisplay extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Array,
  })
  value!: array;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_2526: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_2525: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_2526 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_2525 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_2526,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_2525],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_2526,
      evh_7315092382398562_reload_2525,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("TransactionNotesDisplay", TransactionNotesDisplay);

</script>